import { createReducer } from 'reduxsauce';
import { MedicaldegreeReducerTypes } from '../types';

import Types from './actions-types';

export const INITIAL_STATE: MedicaldegreeReducerTypes = {
  list: [],
  pagination: {
    count: 8,
    total: 8,
    page: 1,
    filter: '',
    s: null,
  },
  isLoading: false,
  hasError: false,
};

export const listRequest = (state = INITIAL_STATE, action: any) => {
  return {
    ...state,
    pagination: { ...state.pagination, ...action.filters },
    isLoading: true,
  };
};

export const listRequestSuccess = (state = INITIAL_STATE, action: any) => {
  const { data, ...pagination } = action;

  return {
    ...state,
    list: data.data,
    pagination: { ...state.pagination, ...pagination },
    isLoading: false,
    hasError: false,
  };
};

export const listRequestError = (state = INITIAL_STATE) => {
  return {
    ...state,
    isLoading: false,
    hasError: true,
  };
};

export const clearStore = (state = INITIAL_STATE) => INITIAL_STATE;

export const HANDLERS = {
  [Types.MEDICAL_DEGREES_LIST_REQUEST as string]: listRequest,
  [Types.MEDICAL_DEGREES_LIST_REQUEST_SUCCESS as string]: listRequestSuccess,
  [Types.MEDICAL_DEGREES_LIST_REQUEST_ERROR as string]: listRequestError,

  [Types.CLEAR_STORE as string]: clearStore,
};

export default createReducer(INITIAL_STATE, HANDLERS);
